import type { MessageKey } from "./ru"

export const deMessages = {
  "common.loading": "Wird geladen...",
  "common.error": "Fehler",
  "common.back": "Zurück",
  "common.next": "Weiter",
  "common.search": "Suchen",
  "auth.loginErrorTitle": "Anmeldefehler",
  "auth.openViaTelegram": "Öffne die App über Telegram",
  "auth.telegramRequired": "Die App muss über Telegram geöffnet werden",
  "auth.authorizationError": "Autorisierungsfehler",
  "device.rotatePortrait": "Drehe dein Gerät ins Hochformat",
  "country.brazil": "Brasilien",
  "country.vietnam": "Vietnam",
  "country.egypt": "Ägypten",
  "country.india": "Indien",
  "country.indonesia": "Indonesien",
  "country.iran": "Iran",
  "country.spain": "Spanien",
  "country.italy": "Italien",
  "country.kazakhstan": "Kasachstan",
  "country.colombia": "Kolumbien",
  "country.malaysia": "Malaysia",
  "country.mexico": "Mexiko",
  "country.nigeria": "Nigeria",
  "country.pakistan": "Pakistan",
  "country.russia": "Russland",
  "country.usa": "Vereinigte Staaten",
  "country.turkey": "Türkei",
  "country.uzbekistan": "Usbekistan",
  "country.ukraine": "Ukraine",
  "country.philippines": "Philippinen",
  "countrySelection.chooseCountry": "Land auswählen",
  "countrySelection.openAria": "Land auswählen",
  "languageSelection.chooseLanguage": "Sprache auswählen",
  "commercial.direction.autotrade": "AutoMarkt",
  "commercial.direction.insurance": "Versicherung",
  "commercial.direction.pitstop": "Pit Stop",
  "commercial.direction.techhelp": "Pannenhilfe",
  "commercial.searchLabel": "BeepApp-Suche",
  "commercial.cityPlaceholder": "Stadt eingeben",
  "commercial.emptyTitle": "Heute keine Angebote",
  "commercial.emptyLine1": "In deiner Stadt gibt es noch keine aktiven BeepApp-Partner",
  "commercial.emptyLine2": "Wir arbeiten bereits daran, passende Partner zu finden und anzubinden",
  "commercial.emptyLine3": "Neue Angebote erscheinen hier automatisch",
  "commercial.helperLine1": "Gib deine Stadt ein, um",
  "commercial.helperLine2": "verfügbare Angebote zu sehen",
  "commercial.partnerPrompt": "Möchtest du BeepApp-Partner werden?",
  "commercial.apply": "Bewerben",
  "main.admin": "Admin",
  "main.garage": "Garage",
  "main.signalSent": "Signal gesendet",
  "main.partnerInviteUnavailable": "Partnereinladung nicht verfügbar",
  "main.enterPlate": "Kennzeichen eingeben",
  "main.searchError": "Suchfehler",
  "main.signalSendError": "Signal konnte nicht gesendet werden",
  "main.shareCardPrefix": "Kennzeichenkarte",
  "main.shareLinkError": "Link konnte nicht erstellt werden",
  "main.searchByPlateAria": "Nach Kennzeichen suchen",
  "main.russianPlateAria": "Russisches Kennzeichen",
  "main.plateAria": "Kennzeichen",
  "main.findPlateAria": "Kennzeichen finden",
  "main.loadingVehicle": "Kennzeichenkarte wird geladen…",
  "main.leaveSignal": "Signal senden",
  "main.share": "Teilen",
  "signalSelection.chooseType": "Signaltyp auswählen",
  "signalSelection.category.attention": "Persönlich",
  "signalSelection.category.road": "Straße",
  "signalSelection.category.urgent": "Dringend",
  "signalSelection.chooseSignal": "Signal auswählen",
  "signalSelection.suggestOwn": "Eigenen Vorschlag senden",
  "signalConfirmation.title": "Signal bestätigen",
  "signalConfirmation.plateHeading": "Kennzeichen prüfen",
  "signalConfirmation.signalHeading": "Ausgewähltes Signal prüfen",
  "signalConfirmation.replyTitle": "Antwort in Telegram erlauben",
  "signalConfirmation.replyBody": "Aktiviere dies, damit der Kennzeicheninhaber dir\nin Telegram schreiben kann. Antworten sind nur möglich,\nwenn du einen @username hast. Die Entscheidung zu antworten\nbleibt beim Kennzeicheninhaber.",
  "signalConfirmation.consentText": "Ich bestätige, dass dieses Signal eine\nreale Situation widerspiegelt und kein Spam\noder eine Falschmeldung ist.",
  "signalConfirmation.warning": "Nach dem Senden kann das Signal\nnicht mehr geändert werden",
  "signalConfirmation.sending": "Wird gesendet…",
  "signalConfirmation.send": "Senden",
  "partner.loadingAria": "Wird geladen",
  "partner.title": "Partnerprogramm",
  "partner.offerLine1": "Verdiene dauerhaft 30 % an allen Zahlungen",
  "partner.offerLine2": "von Nutzern, die du zu BeepApp einlädst",
  "partner.offerLine3": "über das Telegram-Partnerprogramm",
  "partner.connectUnavailable": "Die Verbindung wird verfügbar, sobald das Telegram-Partnerprogramm eingerichtet ist.",
  "partner.connectTelegram": "In Telegram verbinden",
  "partner.qrAria": "QR-Code des Partnerlinks",
  "partner.download": "Herunterladen",
  "partner.promoHeading": "Persönlichen Promo-Code erstellen",
  "partner.promoHelperLine1": "Der Promo-Code aktiviert ein zusätzliches Abo-Jahr",
  "partner.promoHelperLine2": "und hilft, Nutzer zu gewinnen",
  "partner.promoAria": "Promo-Code",
  "partner.affiliateHeading": "Dein Partnerlink",
  "partner.affiliateHelper": "Speichere den Link, um einen persönlichen QR-Code zu erstellen",
  "partner.affiliateAria": "Partnerlink",
  "partner.qrNoteLine1": "Der QR-Code kann auf deinem Fahrzeug,",
  "partner.qrNoteLine2": "in sozialen Netzwerken und Werbematerialien platziert werden",
  "partner.save": "Speichern",
  "partner.reset": "Zurücksetzen",
  "partner.resetConfirm": "Gespeicherten Partnerlink zurücksetzen? Der Promo-Code bleibt dir erhalten.",
  "partner.promoFormatError": "Der Promo-Code muss 4 bis 15 Zeichen enthalten.",
  "partner.affiliateHostError": "Nur Links zu t.me oder telegram.me sind erlaubt.",
  "partner.affiliatePathError": "Der Link enthält keinen Telegram-Pfad.",
  "partner.affiliateFormatError": "Ungültiger Partnerlink.",
  "partner.loadError": "Ladefehler",
  "partner.checkInputError": "Überprüfe die eingegebenen Daten",
  "garageActivation.promoInvalid": "Promo-Code ist ungültig",
  "garageActivation.plateOccupied": "Dieses Kennzeichen ist bereits verknüpft",
  "garageActivation.activateError": "Garage konnte nicht aktiviert werden",
  "garageEntry.loadJournalError": "Fahrtenbuch konnte nicht geladen werden",
  "garageEntry.loadStatusesError": "Status konnten nicht geladen werden",
  "garageEntry.activationSuccess": "Garage erfolgreich aktiviert",
  "garageEntry.plateAttached": "Kennzeichen verknüpft",
  "garageEntry.attachError": "Kennzeichen konnte nicht verknüpft werden",
  "garageEntry.activationNote": "Aktiviere deine Garage",
  "garageSheet.activationTitle": "Garage aktivieren",
  "garageSheet.plateHelper": "Fahrzeugkennzeichen eingeben",
  "garageSheet.promoHelper": "Hast du einen Promo-Code?",
  "garageSheet.cleanBonusLine1": "Nach der Aktivierung hast du 1 Stunde",
  "garageSheet.cleanBonusLine2": "für einen kostenlosen „Clean Start“",
  "garageSheet.activationFor": "Aktivierung für",
  "garageSheet.cost": "Kosten",
  "garageSheet.ownerConsentLine1": "Ich bestätige, dass ich Eigentümer",
  "garageSheet.ownerConsentLine2": "des Fahrzeugs mit dem angegebenen",
  "garageSheet.ownerConsentLine3": "Kennzeichen bin.",
  "garageSheet.processing": "Verarbeitung...",
  "garageSheet.attach": "Verknüpfen",
  "garageSheet.pay": "Bezahlen",
  "garageLifecycle.cleanTitle": "Clean Start",
  "garageLifecycle.deactivateTitle": "Garage deaktivieren",
  "garageLifecycle.cleanWarningLine1": "Der Kennzeichenverlauf wird gelöscht",
  "garageLifecycle.cleanWarningLine2": "und kann nicht wiederhergestellt werden!",
  "garageLifecycle.deactivateWarningLine1": "Nach der Deaktivierung endet der Zugriff",
  "garageLifecycle.deactivateWarningLine2": "auf aktive Garage-Funktionen",
  "garageLifecycle.willBeDeleted": "WIRD GELÖSCHT",
  "garageLifecycle.cleanRemovedLine1": "• Alle Einträge aus dem Fahrtenbuch",
  "garageLifecycle.cleanRemovedLine2": "• Verlauf empfangener Signale",
  "garageLifecycle.cleanRemovedLine3": "• Öffentliche Signalzähler",
  "garageLifecycle.cleanRemovedLine4": "  auf der Kennzeichenkarte",
  "garageLifecycle.willRemain": "BLEIBT ERHALTEN",
  "garageLifecycle.cleanPreservedLine1": "• Verknüpfung des Kennzeichens mit der Garage",
  "garageLifecycle.cleanPreservedLine2": "• Verbleibende Aktivierungsdauer",
  "garageLifecycle.cleanPreservedLine3": "• Ausgewählter Kennzeichenstatus",
  "garageLifecycle.cleanPreservedLine4": "• Gesamtzahl der Kartenaufrufe",
  "garageLifecycle.freeFirstHour": "In der ersten Stunde kostenlos",
  "garageLifecycle.willBecomeUnavailable": "WIRD NICHT MEHR VERFÜGBAR SEIN",
  "garageLifecycle.deactivateRemovedLine1": "• Fahrtenbuch",
  "garageLifecycle.deactivateRemovedLine2": "• Auswahl und Nutzung des Kennzeichenstatus",
  "garageLifecycle.deactivateRemovedLine3": "• Du verlässt AutoClan automatisch",
  "garageLifecycle.deactivateRemovedLine4": "• AutoMarkt",
  "garageLifecycle.deactivateRemovedLine5": "• Versicherung",
  "garageLifecycle.deactivateRemovedLine6": "• Pit Stop",
  "garageLifecycle.deactivateRemovedLine7": "• Pannenhilfe",
  "garageLifecycle.deactivateRemovedLine8": "• Kennzeichen wird von der Garage getrennt",
  "garageLifecycle.willRemainAvailable": "BLEIBT VERFÜGBAR",
  "garageLifecycle.deactivatePreservedLine1": "• Begleiter",
  "garageLifecycle.deactivatePreservedLine2": "• Dispatcher",
  "garageLifecycle.deactivatePreservedLine3": "• Kennzeichensuche und Anzeige",
  "garageLifecycle.deactivatePreservedLine4": "  der öffentlichen Fahrzeugkarte",
  "garageLifecycle.deactivatePreservedLine5": "• Möglichkeit zur erneuten Aktivierung",
  "garageLifecycle.deactivatePreservedLine6": "  der Garage jederzeit",
  "garageLifecycle.cleanConsentLine1": "Ich stimme der Löschung",
  "garageLifecycle.cleanConsentLine2": "des gesamten Verlaufs dieses Kennzeichens",
  "garageLifecycle.cleanConsentLine3": "ohne Wiederherstellungsmöglichkeit zu.",
  "garageLifecycle.deactivateConsentLine1": "Ich bestätige die Deaktivierung und",
  "garageLifecycle.deactivateConsentLine2": "das Ende des Zugriffs auf alle",
  "garageLifecycle.deactivateConsentLine3": "aktiven Garage-Funktionen.",
  "garageLifecycle.clean": "Löschen",
  "garageLifecycle.deactivate": "Deaktivieren",
} satisfies Record<MessageKey, string>
